import dayjs, {
  Dayjs,
} from 'dayjs';
import {
  dayjsTimezone,
} from '@mobiscroll/react';
import RelativeTime from 'dayjs/plugin/relativeTime';
import IsBetween from 'dayjs/plugin/isBetween';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import minMax from 'dayjs/plugin/minMax';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

/// @INFO: add more plugins if needed here
dayjs.extend(RelativeTime);
dayjs.extend(IsBetween);
dayjs.extend(CustomParseFormat);
dayjs.extend(minMax);
dayjs.extend(utc);
dayjs.extend(timezone);

let defaultTimeZoneId: string = 'utc';

export function setDefaultTimeZoneId(timeZoneId?: string | null) {
  defaultTimeZoneId = timeZoneId ?? 'America/New_York';
  dayjs.tz.setDefault(defaultTimeZoneId);
}

export function getDefaultTimeZoneId() {
  return defaultTimeZoneId;
}

export function getOrgNow(): Dayjs {
  return dayjs().tz();
}

dayjsTimezone.dayjs = dayjs;

// dayjs.extend(...); /* another plugin *

export default dayjs;
export { Dayjs };
